import { render, staticRenderFns } from "./AchievementCreate.vue?vue&type=template&id=b0749cc8"
import script from "./AchievementCreate.vue?vue&type=script&lang=js"
export * from "./AchievementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports